import styled from "styled-components";

type PropsType = {
    languages: string[];
    selected: string;
    onChange: (newLanguageCode: string) => void;
    className: string;
}

export default ({ languages, selected, onChange, className }: PropsType): JSX.Element => (
    <SelectorWrapper>
        {languages.map((item) =>
            <SelectorLabel key={item}>
                <input
                    type="radio"
                    name="language"
                    value={item}
                    checked={selected === item}
                    onChange={() => onChange(item)}
                />
                <span>{item}</span>
            </SelectorLabel>
        )}
    </SelectorWrapper>
);

const SelectorWrapper = styled.div`
    float: left;
`;

const HEIGHT = 20;
const COLOR_NORMAL = "#bfbfbf";
const COLOR_NORMAL_HOVER = "#a6a6a6";
const COLOR_SELECTED = "#4c4c4c";
const COLOR_SELECTED_HOVER = "black";

const SelectorLabel = styled.label`
    display: block;
    position: relative;
    float: left;
    cursor: pointer;
    
    span {
        display: block;
        width: ${HEIGHT + 2}px;
        height: ${HEIGHT - 2}px;
        line-height: ${HEIGHT - 4}px;
        text-align: center;
        border: 1px solid ${COLOR_NORMAL};
        color: ${COLOR_NORMAL};
        border-radius: ${HEIGHT / 3}px;
        text-transform: uppercase;
        font-size: 12px;
        
        @media (pointer: fine) {
            &:hover {
                border-color: ${COLOR_NORMAL_HOVER};
                color: ${COLOR_NORMAL_HOVER};
            }
        }
    }
    
    input:checked + span {
        border-color: ${COLOR_SELECTED};
        color: ${COLOR_SELECTED};
        
        @media (pointer: fine) {
            &:hover {
                border-color: ${COLOR_SELECTED_HOVER};
                color: ${COLOR_SELECTED_HOVER};
            }
        }
    }
    
    input {
        display: block;
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        pointer-events: none;
    }

    &:not(:last-child) {
        margin-right: 5px;
    }
`;